<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Abonos</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="OpenSaveDialog()"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo abono</span>
        </v-tooltip>
        <v-row style="padding: 1rem">
            <v-col cols="12">
                <h3>Importe</h3>
            </v-col>
            <v-col cols="12" md="4">
                <span>Factura: {{ this.totalFactura.toFixed(2) }} €</span>
            </v-col>
            <v-col cols="12" md="4">
                <span>Abonado: {{ this.totalAbonado.toFixed(2) }} €</span>
            </v-col>
            <v-col cols="12" md="4">
                <span>Faltante: {{ faltante.toFixed(2) }} €</span>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Abonos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    @click="openEditModal(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="EDITAR"
                    >mdi-pencil-outline</v-icon
                >
                <!-- <v-icon
                    @click="openAsientoModal(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="APUNTES"
                    >mdi-cash</v-icon
                > -->
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>
        <v-dialog v-model="save_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Guardar abono
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-row>
                        <v-col col="12" md="6">
                            <date-select v-model="abono.fecha" label="Fecha">
                            </date-select>
                        </v-col>
                        <v-col col="12" md="6">
                            <v-text-field
                                v-model="abono.importe"
                                type="number"
                                label="Importe"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            save_dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="SaveAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteAbono()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- <DialogLibroDiario
            v-model="asiento_dialog"
            :id_factura="factura.id"
            :extra="facturaAsiento"
            :id_cliente="factura.id_cliente"
            :id_abono="abono.id"
            :abono="abono.importe"
        ></DialogLibroDiario> -->
    </v-card>
</template>
<script>
import DialogLibroDiario from "../../libroDiario/componentes/DialogLibroDiario.vue";
export default {
    components: { DialogLibroDiario },
    data() {
        return {
            asiento_dialog: false,
            factura: {},
            save_dialog: null,
            search: "",
            headers: [
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Proveedor", value: "proveedor.nombre", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            abono: {
                id: null,
                id_factura: this.$route.query.id,
                id_proveedor: null,
                fecha: null,
                importe: null,
            },
            Abonos: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        if (this.$route.query.id) {
            this.getAbonos(this.$route.query.id);
        }
    },
    methods: {
        openAsientoModal(item) {
            this.abono.id = item.id;
            this.abono.importe = item.importe;
            this.asiento_dialog = true;
        },
        openEditModal(item) {
            this.abono.id = item.id;
            this.abono.fecha = item.fecha;
            this.abono.importe = item.importe;
            this.save_dialog = true;
        },
        ClearAbono() {
            this.abono.id = null;
            this.abono.fecha = null;
            this.abono.importe = null;
        },
        SaveAbono() {
            axios.post(`api/save-abono-entrante`, this.abono).then(
                (res) => {
                    this.$toast.sucs("Abono guardado");
                    this.save_dialog = false;
                    this.getAbonos(this.$route.query.id);
                },
                (err) => {
                    //console.log(error.response.status);
                    if (error.response.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Algo salió mal");
                    }
                }
            );
        },
        CloseSaveDialog() {
            this.save_dialog = false;
        },
        OpenSaveDialog() {
            this.ClearAbono();

            this.save_dialog = true;
        },
        getFactura(id) {
            axios.get(`api/get-factura-entrante/${id}`).then(
                (res) => {
                    this.factura = res.data.data;
                    this.abono.id_proveedor = this.factura.proveedor.id
                    // this.factura.total =  this.factura.iva 
                },
                (err) => {
                    this.$custom_error("Error consultando los abonos");
                }
            );
        },
        getAbonos(id) {
            axios.get(`api/get-abonos-entrante/${id}?busqueda=${this.search}`).then(
                (res) => {
                    this.Abonos = res.data.abonos.data;

                    console.log('abonos', this.Abonos);

                    this.getFactura(id);
                },
                (err) => {
                    this.$custom_error("Error consultando los abonos");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.Abonos.indexOf(item);
            this.dialog = true;
        },
        deleteAbono() {
            axios
                .delete(`api/delete-abono-entrante/${this.Abonos[this.selectedItem].id}`)
                .then(
                    (res) => {
                        this.$toast.sucs("Abono eliminado con éxito");
                        this.dialog = false;
                        this.getAbonos(this.$route.query.id);
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el abono");
                    }
                );
        },
    },
    computed: {
        totalFactura () {
            if (!this.factura || this.factura.total == null) return 0;
            if (this.factura.total_a_pagar != null) return parseFloat(this.factura.total_a_pagar);
            const base = parseFloat(this.factura.total) || 0;
            const iva = parseFloat(this.factura.iva) || 0;
            const retencion = parseFloat(this.factura.importe_retencion) || 0;
            return Math.round((base + iva - retencion) * 100) / 100;
        },
        totalAbonado () {
            let total = 0;

            this.Abonos.forEach(element => {
                total += element.importe 
            });

            return total;
        },
        // Pendiente por pagar/cobrar: nunca negativo (si está cubierto o es devolución, 0)
        faltante () {
            const pendiente = this.totalFactura - this.totalAbonado;
            return Math.max(0, Math.round(pendiente * 100) / 100);
        },
        // facturaAsiento() {
        //     let factura = this.factura;
        //     factura.valor_iva =
        //         factura.total * (!this.$route.meta.nota ? 0.21 : 0);
        //     factura.subtotal = factura.total;
        //     factura.total =
        //         factura.subtotal * (!this.$route.meta.nota ? 1.21 : 1);
        //     factura.iva = !this.$route.meta.nota ? 21 : 0;
        //     return factura;
        // },
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
